module.exports = __webpack_public_path__ + "static/img/6666.c589d0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/6666.jpg
// module id = 2CuD
// module chunks = 1